/**
 * This clones an object and deletes the keys holding any empty values.
 */

export function clean<T extends Record<string, any>>(obj: T): Partial<T> {
  const cloned = { ...obj };
  for (const key in Object.keys(cloned)) {
    if (cloned[key] === "" || cloned[key] === undefined || cloned[key] === null) {
      delete cloned[key];
    }
  }
  return cloned;
}

/**
 * This map is different from the Array.map function because it is a generator, which
 * means that if we have an expensive function, this map will only call that function
 * one at a time, waiting for some outer loop (such as the find() below) to iterate over
 * each individually, and will bail out when that is done.
 */
export function* map<Input, Output>(
  array: Input[],
  fn: (arg: Input, index: number) => Output
): Generator<Output> {
  for (let i = 0; i < array.length; i++) {
    yield fn(array[i], i);
  }
}

export function find<Input>(
  array: Generator<Input>,
  fn: (arg: Input) => boolean = Boolean
): Input | undefined {
  for (const x of array) {
    if (fn(x)) {
      return x;
    }
  }
}
